import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["filterForm", "batchActionForm", "batchActionDropdown"]
  static values = {gridName: String, batchActionUrl: String}

  #customFilterForm = null
  #selectedIds = []
  #batchActionDropdownController = null

  initialize() {
    this.submitNewCustomFilterForm = this.submitNewCustomFilterForm.bind(this)
    this.updateBatchActionsDropdown = this.updateBatchActionsDropdown.bind(this)
  }

  connect() {
    this.#customFilterForm = this.element.querySelector(`form[data-form='custom-form'][data-grid='${this.gridNameValue}']`)
    if (this.#customFilterForm) {
      this.#customFilterForm.addEventListener("submit", this.submitNewCustomFilterForm)
    }
    if (this.hasBatchActionDropdownTarget) {
      this.batchActionDropdownTarget.addEventListener("connected", () => {
        this.#batchActionDropdownController = this.batchActionDropdownTarget["dropdown--component"]
        this.updateBatchActionsDropdown()
      })
    }
  }

  submitNewCustomFilterForm(e) {
    e.preventDefault();
    const form = e.currentTarget
    const filtersInput = form.querySelector("input[name='filters']")
    const data = new FormData(this.filterFormTarget);
    let d = {};
    for (const pair of data.entries()) {
      let key = pair[0];
      const value = pair[1];
      const regex = /([A-Za-z_]+)\[([A-Za-z_]*)\](.*)/;
      key = key.replace(regex, "$2$3");
      if (key in ["scope", "search"])
        continue
      if (key.endsWith("[]")) {
        const keyclean = key.substring(0, key.length - 2);
        if (!d[keyclean])
          d[keyclean] = [];
        d[keyclean].push(value);
      } else {
        d[key] = value;
      }
    }
    const json = JSON.stringify(d);
    const hiddenInput = form.querySelector("input[name='filters']")
    hiddenInput.value = json
    form.submit();
  }

  // Grouped Actions

  toggleSelectedId(event) {
    const id = event.currentTarget.dataset.id
    if (event.currentTarget.checked) {
      this.#selectedIds.push(id);
    } else {
      this.#selectedIds = this.#selectedIds.filter(i => i !== id);
      this.element.querySelector("[type='checkbox'][name='select_all']").checked = false
    }
    this.updateBatchActionsDropdown()
  }

  selectAll(event) {
    const checkBoxes = this.element.querySelectorAll("[type='checkbox'][name='select_row']")
    if (event.currentTarget.checked) {
      checkBoxes.forEach(c => {
        c.checked = true
      })
      this.#selectedIds = Array.from(checkBoxes).map(c => c.dataset.id)
    } else {
      checkBoxes.forEach(c => {
        c.checked = false
      })
      this.#selectedIds = []
    }
    this.updateBatchActionsDropdown()
  }

  updateBatchActionsDropdown() {
    if (!this.#batchActionDropdownController)
      return
    if (this.#selectedIds.length > 0) {
      // Enable batch actions dropdown
      this.#batchActionDropdownController.enable()
    } else {
      // Disable batch actions dropdown
      this.#batchActionDropdownController.disable()
    }
  }

  async callGroupedAction(event) {
    event.preventDefault()
    event.stopPropagation()

    if (confirm("Confirmer l'action ?")) {
      const actionBtn = event.currentTarget
      const name = actionBtn.dataset.name

      const actionInput = this.batchActionFormTarget.querySelector('[name="action_name"]')
      actionInput.value = name
      const selectedIdsList = this.batchActionFormTarget.querySelector('.selected-ids')
      selectedIdsList.innerHTML = ""
      this.#selectedIds.forEach(id => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "selected_ids[]"; // Name it as an array
        input.value = id;
        selectedIdsList.appendChild(input);
      })
      // Set turbo frame attribute on form
      if (actionBtn.dataset.turboFrame) {
        this.batchActionFormTarget.dataset.turboFrame = actionBtn.dataset.turboFrame
      } else {
        delete this.batchActionFormTarget.dataset.turboFrame
      }

      this.batchActionFormTarget.requestSubmit()
    }
  }
}
